<template>
  <div class="lead-sf-import-status">
    <ImportStatus
      v-for="task in sfReportImportTasks"
      :key="task.id"
      :target-task="task"
      :progress-message="$t('import.salesforce.status.progress')"
      :error-message="$t('import.salesforce.status.error')"
      :error-modal-title="$t('import.salesforce.errorTitle')"
      :success-message="$t('import.salesforce.status.success')"
      @confirm="() => confirmTask(task.id)"
      @success="$emit('success')"
    />
  </div>
</template>

<script>
import { mapWaitingActions } from 'vue-wait';
import { mapGetters } from 'vuex';
import ImportStatus from '@/components/organisms/user/leadImport/ImportStatus.vue';

export default {
  name: 'LeadSfImportStatus',
  components: {
    ImportStatus,
  },
  emits: [
    'success',
  ],
  computed: {
    ...mapGetters('user', ['sfReportImportTasks']),
  },
  created() {
    this.getSfReportImportTasksAction();
    this.timeObj = this.$setInterval(() => {
      this.getSfReportImportTasksAction();
    }, 30000);
  },
  beforeUnmount() {
    this.$clearInterval(this.timeObj);
  },
  methods: {
    ...mapWaitingActions('user', {
      getSfReportImportTasksAction: 'getLeadSfImportTasksWait',
      confirmSfReportImportTaskAction: 'confirmSfReportImportTaskWait',
    }),
    confirmTask(taskId) {
      this.confirmSfReportImportTaskAction({ SfReportImportTaskId: taskId });
    },
  },
};
</script>

<style scoped lang="scss">
  .import-status:nth-last-child(n + 2) {
    border-bottom: 1px solid $concrete-light;
  }
</style>
